import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';
export const findById: FindById<'targetingRules'> = createFindById('targetingRules');
export const findByIdThrows: FindByIdThrows<'targetingRules'> = createFindByIdThrows('targetingRules');
